import { useState, useRef } from "react";
import { Camera, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSiteImages, absUrl } from "@/lib/siteConfig";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function EditableImage({ slot, defaultSrc, alt = "", className = "", imgClassName = "w-full h-full object-cover", editable = true }) {
  const { user } = useAuth();
  const isAdmin = editable && user?.role === "admin";
  const { images, setImage } = useSiteImages();
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);
  const src = images[slot] ? absUrl(images[slot]) : defaultSrc;

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/upload/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.put("/settings/image", { slot, url: data.url });
      setImage(slot, data.url);
      toast.success("Immagine aggiornata");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setUploading(false); }
  };

  return (
    <div className={`relative group/img ${className}`}>
      <img src={src} alt={alt} className={imgClassName} />
      {isAdmin && (
        <>
          <button
            type="button"
            data-testid={`change-image-${slot}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); inputRef.current?.click(); }}
            className="absolute top-3 right-3 z-10 inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-full bg-black/70 text-white hover:bg-gold hover:text-[#020617] cursor-pointer opacity-0 group-hover/img:opacity-100 transition-opacity"
          >
            {uploading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Camera className="w-3.5 h-3.5" />} Cambia immagine
          </button>
          <input ref={inputRef} type="file" className="hidden" onClick={(e) => e.stopPropagation()} onChange={(e) => upload(e.target.files?.[0])} />
        </>
      )}
    </div>
  );
}
